<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlan: getDeliveryPlanVehicleInformation
}>();
</script>
<template>
  <div
    class="w-100 ml-2 my-6"
  >
    <div class="w-100 d-flex ml-2 mt-2">
      <div class="w-25">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineRollbackForm.tripId') }}
        </div>
      </div>
      <div class="text-label-large w-100">
        {{ props.deliveryPlan.delivery_plan_id }}
      </div>
    </div>
    <div class="w-100 d-flex ml-2 mt-2">
      <div class="w-25">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineRollbackForm.numberPlate') }}
        </div>
      </div>
      <div class="text-label-large w-100">
        {{ props.deliveryPlan.car_number }}
      </div>
    </div>
    <div class="w-100 d-flex ml-2 mt-2">
      <div class="w-25">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineRollbackForm.driver') }}
        </div>
      </div>
      <div class="text-label-large w-100">
        {{ props.deliveryPlan.driver.full_name }}
      </div>
    </div>
    <div class="w-100 d-flex ml-2 mt-2">
      <div class="w-25">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineRollbackForm.leavingWarehouse') }}
        </div>
      </div>
      <div class="text-label-large w-100">
        {{ formatDateTime(new Date(props.deliveryPlan.leaving_warehouse_date_time)) }}
      </div>
    </div>
    <div class="w-100 d-flex ml-2 my-2">
      <div class="w-25">
        <div class="text-label-large font-weight-bold">
          {{ i18n.global.t('pages.dailyReports.combineRollbackForm.returningWarehouse') }}
        </div>
      </div>
      <div class="text-label-large w-100">
        {{ formatDateTime(new Date(props.deliveryPlan.returning_warehouse_date_time)) }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.text-label-large {
  font-size: 18px;
}
</style>
